export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20aerial%20flat%20lay%20of%20premium%20lifestyle%20products%20including%20designer%20sneakers%20accessories%20and%20fashion%20items%20arranged%20on%20soft%20cream%20textured%20surface%2C%20gentle%20diffused%20natural%20daylight%20from%20above%2C%20European%20editorial%20style%20photography%2C%20warm%20beige%20sand%20and%20ivory%20tones%2C%20organic%20freeform%20composition%20with%20elegant%20negative%20space%2C%20soft%20shadows%2C%20elevated%20modern%20lifestyle%20aesthetic%2C%20high%20detail%20product%20textures&width=1800&height=1200&seq=hero-bg-main-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti"
          className="w-full h-full object-cover"
          title="Itaobuy Spreadsheet prodotti in evidenza"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 md:px-10 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/70 backdrop-blur-sm border border-background-200/40 mb-8">
          <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">Guide aggiornate 2026 · Italia</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.08] mb-6">
          Itaobuy Spreadsheet:
          <br />
          <span className="text-primary-300">la guida italiana</span> per trovare
          <br />
          i migliori prodotti online
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-[600px] mx-auto mb-10 leading-relaxed">
          Trova, confronta e analizza migliaia di prodotti con Itaobuy Spreadsheet.
          Una risorsa completa per utenti italiani che vogliono scoprire prodotti selezionati,
          categorie popolari e strategie per risparmiare.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-16">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            itaobuy sheet
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 font-semibold text-base hover:bg-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-200/30"
          >
            Buy It Now
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-bag-line"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-[700px] mx-auto">
          {[
            { icon: 'ri-checkbox-circle-line', text: 'Guide aggiornate 2026' },
            { icon: 'ri-bar-chart-line', text: 'Analisi prodotti' },
            { icon: 'ri-shield-check-line', text: 'Consigli sicurezza' },
            { icon: 'ri-table-line', text: 'Tabelle confronto' },
          ].map((badge) => (
            <div
              key={badge.text}
              className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/15"
            >
              <span className="w-5 h-5 flex items-center justify-center text-primary-300">
                <i className={badge.icon}></i>
              </span>
              <span className="text-xs font-medium text-background-50/90 whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-50/50">
          <i className="ri-arrow-down-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}